import { get, patch, post } from '../../utils/http';

export const fetchBranches = ({ accountId }) => get(`/accounts/${accountId}/branches`);

export const addBranch = ({ accountId, branch }) => post(`/accounts/${accountId}/branches`, branch);

export const updateBranch = ({ accountId, branchId, branch }) =>
  patch(`/accounts/${accountId}/branches/${branchId}`, branch);

export const copyBranchSettings = ({ accountId, sourceBranchId, destinationBranchId }) =>
  post(`/accounts/${accountId}/branches/copy-settings`, {
    sourceBranchId,
    destinationBranchId
  });
